import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import storeJs from 'store';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import pretty from 'pretty';
import { baseApiUrl } from '../../../api/ApiHelpers';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  CodeField,
} from '../../form';

class EmailTemplateCustom extends Component {
  state = { cb: new Date().getTime(), previewImageMapping: false }

  onFormSubmit(values) {
    const { dispatch, emailTemplate } = this.props;

    dispatch(setLoader('EmailTemplateSettingsForm'));
    dispatch(PublisherApi.actions.emailTemplateUpdate.post(emailTemplate.uuid, values, (_error, success) => {
      dispatch(removeLoader('EmailTemplateSettingsForm'));
      if (success) {
        dispatch({
          type: PublisherApi.events.emailTemplate.actionSuccess,
          syncing: false,
          data: { data: { ...success.data } }
        });

        this.setState({
          cb: new Date().getTime()
        });
      }
    }));
  }

  handlePreviewChange(event) {
    this.setState({ previewImageMapping: event.target.checked ? true : false });
  }

  render() {
    const { handleSubmit, isLoading, website } = this.props;
    const jtoken = storeJs.get('jwt');
    const url = `${baseApiUrl}/v1/publisher/email_templates/email_preview?
      &access_token=${jtoken}&website_id=${website.uuid}&cb=${this.state.cb}&t=custom&o=${this.state.previewImageMapping}`;

    return (
      <form
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
        className='m-t'
      >
        <h4 className="control-label">Preview</h4>
        <div className="text-center m-b-lg">
          <img
            src={url}
            width='600'
            alt='ads'
            style={{
              border: 0,
              height: 'auto !important',
              outline: 'none',
              textDecoration: 'none',
              msInterpolationMode: 'bicubic',
              background: 'white',
              boxShadow: '0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)'
            }}
          />
        </div>
        <div
          style={{
            margin: 'auto',
            width: '600px',
            textAlign: 'right'
          }}
        >
          <label
            htmlFor="preview-with-overlay"
          >
            Preview Link Mappings
          </label>
          <input
            id="preview-with-overlay"
            type="checkbox"
            style={{ marginLeft: '5px' }}
            value={this.state.previewImageMapping}
            onChange={this.handlePreviewChange.bind(this)}
          />
        </div>
        <div style={{ height: 500, overflow: 'auto' }}>
          <Field
            name='email_template[snippet]'
            label='Custom Template'
            component={CodeField}
            insertItems={[
              {
                displayText: 'Slot Wrapper',
                text: `
                <%jobs.each do |j|%>
                  <!-- Insert your slots here -->
                <%end%>
                `
              },
              {
                displayText: 'Title',
                text: '<%=j["title"]%>'
              },
              {
                displayText: 'Company',
                text: '<%=j["company"]%>'
              },
              {
                displayText: 'Job Description',
                text: '<%=j["description"]%>'
              },
              {
                displayText: 'Location',
                text: '<%=j["location"]%>'
              },
              {
                displayText: 'Date',
                text: '<%=j["date"]%>'
              }
            ]}
          />
        </div>

        <Button
          className="m-t-lg"
          type='submit'
          loading={isLoading}
          bsStyle='primary'
        >
          Update
        </Button>
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'EmailTemplateSettingsForm',
  enableReinitialize: true
});

const mapStateToProps = (state, ownProps) => {
  const { loader, form } = state;
  const { emailTemplate } = ownProps;
  const initialValues = {
    email_template: {
      snippet: pretty(get(emailTemplate, 'snippet', ''))
    }
  };

  const isLoading = loader.includes('EmailTemplateSettingsForm');
  const formData = get(form, 'EmailTemplateSettingsForm.values', {});

  return { isLoading, initialValues, formData };
};

export default connect(mapStateToProps)(ResourceForm(EmailTemplateCustom));
